export default __webpack_public_path__ + "static/media/file-search.a5e771f3.svg";